import { browserStatics } from "@/src/shared/BrowserStatic";

const currencyFormatters: Map<string, Intl.NumberFormat> = new Map();

export const polishCurrencyFormatter = (n: number | string) => {
    if (typeof n === "string") {
        n = Number.parseInt(n, 10);
    }

    let formatter: Intl.NumberFormat | undefined = currencyFormatters.get("pl-PL");

    if (!formatter) {
        formatter = new Intl.NumberFormat("pl-PL", {
            style: "currency",
            currency: "PLN",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true,
        });

        currencyFormatters.set("pl-PL", formatter);
    }

    return formatter.format(n);
};

const numberFormater: Map<string, Intl.NumberFormat> = new Map();

export const numberFormatter = (n: number | string, decimal: number = 2) => {
    if (typeof n === "string") {
        n = Number.parseInt(n);
    }

    let formatter: Intl.NumberFormat | undefined = numberFormater.get(browserStatics.culture);

    if (!formatter) {
        formatter = new Intl.NumberFormat(browserStatics.culture, {
            style: "decimal",
            maximumFractionDigits: decimal,
            minimumFractionDigits: decimal,
        });

        numberFormater.set("pl-PL", formatter);
    }

    return formatter.format(n);
};
